export default[ //Students
      {
        path: "/029a0624b7bb94300b609fef",
        children: [
          {
            path: "005ec0ced28745d317de3350",
            name: "saiqe25.students",
            meta: {
              title: "SAIQE 2025 students",
              authRequired: true,
              acc:['y52800']
            },
            component: () => import("@/views/saiqe/twf/student/index.vue"),
          },
          {
            path: "00663027fda73d477c432297",
            name: "saiqe25.student.create",
            meta: {
              title: "Create SAIQE 2025 student",
              authRequired: true,
              acc :['y49910']
            },
            component: () => import("@/views/saiqe/twf/student/create.vue"),
          },
          {
            path: "01234bade99cdc8825fcfcb2/:str?",
            name: "saiqe25.student",
            meta: {
              title: "View SAIQE 2025 student",
              acc: ['y49910']
            },
            component: () => import("@/views/saiqe/twf/student/view.vue"),
          },
          {
            path: "02393ea408746a5b90ddcca1/:str?",
            name: "saiqe25.studentedit",
            meta: {
              title: "Edit SAIQE 2025 student",
              acc: ['y98201']
            },
            component: () => import("@/views/saiqe/twf/student/edit.vue"),
          },
          // {
          //   path: "generate",
          //   name: "generateExamNumber",
          //   meta: {
          //     title: "GENERATE EXAM NUMBER",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/generateExamNumber.vue"),
          // },
          // {
          //   path: "export",
          //   name: "exportStudents",
          //   meta: {
          //     title: "EXPORT STUDENTS",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/exportStudents.vue"),
          // },
        ],
      },]